import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "antd/lib/divider/style";
import _Divider from "antd/lib/divider";
import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import "antd/lib/menu/style";
import _Menu from "antd/lib/menu";
import "antd/lib/typography/style";
import _Typography from "antd/lib/typography";
import "antd/lib/layout/style";
import _Layout from "antd/lib/layout";
import _isEmpty from "lodash/isEmpty";
import _isNil from "lodash/isNil";
import _isEqual from "lodash/isEqual";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.filter.js";
/* eslint-disable react/no-this-in-sfc */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DndProvider } from 'react-dnd-multi-backend';
import { HTML5toTouch } from 'rdndmb-html5-to-touch';
import { BuildOutlined, FundViewOutlined, BarChartOutlined, NodeExpandOutlined, FileDoneOutlined, DotChartOutlined, ReadOutlined, ExperimentOutlined, CommentOutlined, TableOutlined } from '@ant-design/icons';
import pipelineErrorUserMessages from 'utils/pipelineErrorUserMessages';
import TermsOfUseIntercept from 'components/data-management/TermsOfUseIntercept';
import BrowserAlert from 'components/BrowserAlert';
import PreloadContent from 'components/PreloadContent';
import GEM2SLoadingScreen from 'components/GEM2SLoadingScreen';
import PipelineRedirectToDataProcessing from 'components/PipelineRedirectToDataProcessing';
import { getBackendStatus, getHasSampleTech, getIsImmuneOnly } from 'redux/selectors';
import SampleTech, { preprocessedSampleTechs } from 'const/enums/SampleTech';
import { loadUser } from 'redux/actions/user';
import { loadBackendStatus } from 'redux/actions/backendStatus';
import { isBrowser } from 'utils/deploymentInfo';
import { modules, brandColors } from 'const';
import { useAppRouter } from 'utils/AppRouteProvider';
import experimentUpdatesHandler from 'utils/experimentUpdatesHandler';
import workerHeartbeatHandler from 'utils/work/workerHeartbeatHandler';
import integrationTestConstants from 'utils/integrationTestConstants';
import pipelineStatusValues from 'utils/pipelineStatusValues';
import useWorkerKeepalive from 'utils/work/useWorkerKeepalive';
import { loadSamples } from 'redux/actions/samples';
import calculatePipelinesRerunStatus from 'utils/data-management/calculatePipelinesRerunStatus';
import termsOfUseNotAccepted from 'utils/termsOfUseNotAccepted';
import SidebarMenuTitle from 'utils/SidebarMenuTitle';
import { CookieBanner, TopBanner } from './banners';
import FeedbackButton from './sider/FeedbackButton';
import UserButton from './sider/UserButton';
import LinkButton from './sider/LinkButton';
import ImmuneOnlyLoadingScreen from './ImmuneOnlyLoadingScreen';
import PlatformError from './PlatformError';
var Sider = _Layout.Sider;
var Text = _Typography.Text;
var Item = _Menu.Item,
  SubMenu = _Menu.SubMenu,
  ItemGroup = _Menu.ItemGroup;
var checkEveryIsValue = function checkEveryIsValue(arr, value) {
  return arr.every(function (item) {
    return item === value;
  });
};
var backendErrors = [pipelineStatusValues.FAILED, pipelineStatusValues.TIMED_OUT, pipelineStatusValues.ABORTED];
var BigLogo = function BigLogo() {
  return __jsx("div", {
    style: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: "linear-gradient(315deg, ".concat(brandColors.DARK_LILAC, " 0%, ").concat(brandColors.INDIGO, " 30%, ").concat(brandColors.DARK_INDIGO, " 100%)"),
      paddingTop: '10px',
      paddingBottom: '10px',
      pointerEvents: 'none',
      userSelect: 'none'
    }
  }, __jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 50
  }, __jsx("defs", {
    id: "svg_document_defs"
  }, __jsx("style", {
    id: "M Plus 2_Google_Webfont_import"
  }, "@import url(https://fonts.googleapis.com/css2?family=M+PLUS+2:wght@100..900&display=swap);")), __jsx("g", {
    transform: "translate(20, 21)"
  }, __jsx("image", {
    href: "/Parse_icon_white.png",
    x: "-12",
    y: "-17",
    width: "22%"
  }), __jsx("text", {
    style: {
      outlineStyle: 'none'
    },
    fontWeight: "900",
    textRendering: "geometricPrecision",
    fontFamily: "M Plus 2",
    fill: "#F0F2F5",
    fontSize: "22.00px",
    textAnchor: "start",
    dominantBaseline: "middle",
    x: "35"
  }, "Trailmaker"), __jsx("text", {
    style: {
      outlineStyle: 'none'
    },
    fontWeight: "400",
    textRendering: "geometricPrecision",
    fontFamily: "M Plus 2",
    fill: "#F0F2F5",
    fontSize: "12.00px",
    textAnchor: "start",
    dominantBaseline: "middle",
    x: "35",
    y: "18"
  }, "by Parse Biosciences"))));
};
var SmallLogo = function SmallLogo() {
  return __jsx("div", {
    style: {
      background: "linear-gradient(315deg, ".concat(brandColors.DARK_LILAC, " 0%, ").concat(brandColors.INDIGO, " 30%, ").concat(brandColors.DARK_INDIGO, " 100%)"),
      paddingTop: '8px',
      paddingBottom: '8px',
      pointerEvents: 'none',
      userSelect: 'none'
    }
  }, __jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 30
  }, __jsx("defs", {
    id: "svg_document_defs"
  }, __jsx("style", {
    id: "M Plus 2_Google_Webfont_import"
  }, "@import url(https://fonts.googleapis.com/css2?family=M+PLUS+2:wght@100..900&display=swap);")), __jsx("g", null, __jsx("image", {
    href: "/Parse_icon_white.png",
    x: "20",
    y: "0",
    width: "35%"
  }))));
};
var ContentWrapper = function ContentWrapper(props) {
  var _useSelector4, _backendStatus$pipeli, _backendStatus$gem2s, _backendStatus$gem2s2, _backendStatus$gem2s3, _backendStatus$seurat, _backendStatus$seurat2;
  var dispatch = useDispatch();
  var _useState = useState(false),
    collapsed = _useState[0],
    setCollapsed = _useState[1];
  var _useState2 = useState(0),
    topBannerHeight = _useState2[0],
    setTopBannerHeight = _useState2[1];
  var routeExperimentId = props.routeExperimentId,
    routeAnalysisId = props.routeAnalysisId,
    experimentData = props.experimentData,
    children = props.children;
  var _useAppRouter = useAppRouter(),
    navigateTo = _useAppRouter.navigateTo,
    currentModule = _useAppRouter.currentModule;

  // Keep the worker pod allocated while the user is on an experiment page.
  useWorkerKeepalive(routeExperimentId);
  var currentExperimentIdRef = useRef(routeExperimentId);
  var currentAnalysisIdRef = useRef(routeAnalysisId);
  var selectedExperimentID = useSelector(function (state) {
    var _state$experiments;
    return state === null || state === void 0 || (_state$experiments = state.experiments) === null || _state$experiments === void 0 || (_state$experiments = _state$experiments.meta) === null || _state$experiments === void 0 ? void 0 : _state$experiments.activeExperimentId;
  });
  var selectedAnalysisID = useSelector(function (state) {
    var _state$secondaryAnaly;
    return state === null || state === void 0 || (_state$secondaryAnaly = state.secondaryAnalyses) === null || _state$secondaryAnaly === void 0 || (_state$secondaryAnaly = _state$secondaryAnaly.meta) === null || _state$secondaryAnaly === void 0 ? void 0 : _state$secondaryAnaly.activeSecondaryAnalysisId;
  });
  var domainName = useSelector(function (state) {
    return state.networkResources.domainName;
  });
  var user = useSelector(function (state) {
    return state.user.current;
  });
  var userLoadError = useSelector(function (state) {
    return state.user.error;
  });
  var samples = useSelector(function (state) {
    return state.samples;
  });
  useEffect(function () {
    // selectedExperimentID holds the value in redux of the selected experiment
    // after loading a page it is determined whether to use that ID or the ID in the route URL
    // i.e. when we are in data management there is not exp ID in the URL so we get it from redux
    if (!selectedExperimentID && !routeExperimentId) return;
    if (currentModule === modules.DATA_MANAGEMENT) {
      currentExperimentIdRef.current = selectedExperimentID;
      return;
    }
    if (currentExperimentIdRef.current === routeExperimentId) return;
    currentExperimentIdRef.current = routeExperimentId;
  }, [currentModule, selectedExperimentID, routeExperimentId]);
  useEffect(function () {
    if (currentModule === modules.SECONDARY_ANALYSIS) {
      currentAnalysisIdRef.current = selectedAnalysisID;
    } else if (currentModule === modules.SECONDARY_ANALYSIS_OUTPUT) {
      currentAnalysisIdRef.current = routeAnalysisId;
    }
  }, [currentModule, selectedAnalysisID]);
  var currentExperimentId = currentExperimentIdRef.current;
  var experiment = useSelector(function (state) {
    return state === null || state === void 0 ? void 0 : state.experiments[currentExperimentId];
  });
  var _useSelector = useSelector(getHasSampleTech(currentExperimentId, preprocessedSampleTechs), _isEqual),
    _useSelector$perTech = _useSelector.perTech,
    hasSeuratTechnology = _useSelector$perTech[SampleTech.SEURAT],
    hasAnndataTechnology = _useSelector$perTech[SampleTech.ANNDATA];
  var isImmuneOnly = useSelector(getIsImmuneOnly());
  var experimentName = (experimentData === null || experimentData === void 0 ? void 0 : experimentData.experimentName) || (experiment === null || experiment === void 0 ? void 0 : experiment.name);
  var secondaryAnalysisName = useSelector(function (state) {
    var _state$secondaryAnaly2;
    return state === null || state === void 0 || (_state$secondaryAnaly2 = state.secondaryAnalyses) === null || _state$secondaryAnaly2 === void 0 || (_state$secondaryAnaly2 = _state$secondaryAnaly2[currentAnalysisIdRef.current]) === null || _state$secondaryAnaly2 === void 0 ? void 0 : _state$secondaryAnaly2.name;
  }, _isEqual);
  var activeSltName = useSelector(function (state) {
    var _state$sampleLoadingT, _state$sampleLoadingT2;
    var _ref = (state === null || state === void 0 || (_state$sampleLoadingT = state.sampleLoadingTables) === null || _state$sampleLoadingT === void 0 ? void 0 : _state$sampleLoadingT.meta) || {},
      activeSltId = _ref.activeSltId;
    return activeSltId ? state === null || state === void 0 || (_state$sampleLoadingT2 = state.sampleLoadingTables) === null || _state$sampleLoadingT2 === void 0 || (_state$sampleLoadingT2 = _state$sampleLoadingT2[activeSltId]) === null || _state$sampleLoadingT2 === void 0 ? void 0 : _state$sampleLoadingT2.name : null;
  }, _isEqual);
  var _useSelector2 = useSelector(getBackendStatus(currentExperimentId)),
    backendLoading = _useSelector2.loading,
    backendError = _useSelector2.error,
    backendStatus = _useSelector2.status;
  var _useSelector3 = useSelector(function (state) {
      return state.secondaryAnalyses.meta;
    }),
    activeSecondaryAnalysisId = _useSelector3.activeSecondaryAnalysisId;
  var _ref2 = (_useSelector4 = useSelector(function (state) {
      var _state$secondaryAnaly3;
      return (_state$secondaryAnaly3 = state.secondaryAnalyses[activeSecondaryAnalysisId]) === null || _state$secondaryAnaly3 === void 0 ? void 0 : _state$secondaryAnaly3.status;
    })) !== null && _useSelector4 !== void 0 ? _useSelector4 : {},
    analysisStatus = _ref2.current;
  var qcStatusKey = backendStatus === null || backendStatus === void 0 || (_backendStatus$pipeli = backendStatus.pipeline) === null || _backendStatus$pipeli === void 0 ? void 0 : _backendStatus$pipeli.status;
  var qcRunning = qcStatusKey === 'RUNNING';
  var qcRunningError = backendErrors.includes(qcStatusKey);
  var gem2sStatusKey = backendStatus === null || backendStatus === void 0 || (_backendStatus$gem2s = backendStatus.gem2s) === null || _backendStatus$gem2s === void 0 ? void 0 : _backendStatus$gem2s.status;
  var gem2sProcessType = backendStatus === null || backendStatus === void 0 || (_backendStatus$gem2s2 = backendStatus.gem2s) === null || _backendStatus$gem2s2 === void 0 ? void 0 : _backendStatus$gem2s2.processType;
  var gem2sRunning = gem2sStatusKey === 'RUNNING';
  var gem2sRunningError = backendErrors.includes(gem2sStatusKey);
  var completedGem2sSteps = backendStatus === null || backendStatus === void 0 || (_backendStatus$gem2s3 = backendStatus.gem2s) === null || _backendStatus$gem2s3 === void 0 ? void 0 : _backendStatus$gem2s3.completedSteps;
  var seuratStatusKey = backendStatus === null || backendStatus === void 0 || (_backendStatus$seurat = backendStatus.seurat) === null || _backendStatus$seurat === void 0 ? void 0 : _backendStatus$seurat.status;
  var isSeurat = seuratStatusKey && hasSeuratTechnology;
  // Anndata shares the gem2s pipeline_type bucket rather than having its own top-level
  // backendStatus key like seurat does, so (unlike gem2sProcessType, which only reflects
  // 'anndata' once the pipeline has actually run at least once) this needs to key off sample
  // technology alone, so it's already true immediately after upload, before "Process project"
  // is ever clicked.
  var isAnndata = gem2sStatusKey && hasAnndataTechnology;
  var _useState3 = useState(null),
    pipelinesRerunStatus = _useState3[0],
    setPipelinesRerunStatus = _useState3[1];
  var seuratRunning = seuratStatusKey === 'RUNNING' && isSeurat;
  var seuratRunningError = backendErrors.includes(seuratStatusKey) && isSeurat;
  var completedSeuratSteps = backendStatus === null || backendStatus === void 0 || (_backendStatus$seurat2 = backendStatus.seurat) === null || _backendStatus$seurat2 === void 0 ? void 0 : _backendStatus$seurat2.completedSteps;
  var seuratComplete = seuratStatusKey === pipelineStatusValues.SUCCEEDED && isSeurat;
  var anndataComplete = gem2sStatusKey === pipelineStatusValues.SUCCEEDED && isAnndata;
  // Anndata never launches qc (same as seurat), so don't wait on it once gem2s finishes.
  var waitingForQcToLaunch = !isAnndata && gem2sStatusKey === pipelineStatusValues.SUCCEEDED && qcStatusKey === pipelineStatusValues.NOT_CREATED;
  var copyInProgress = gem2sRunning && gem2sProcessType === 'copy';
  // This is used to prevent a race condition where the page would start loading immediately
  // when the backend status was previously loaded. In that case, `backendLoading` is `false`
  // and would be set to true only in the `loadBackendStatus` action, the time between the
  // two events would allow pages to load.
  var _useState4 = useState(false),
    backendStatusRequested = _useState4[0],
    setBackendStatusRequested = _useState4[1];
  useEffect(function () {
    var _experimentData$sampl;
    if (!currentExperimentId) return;
    if (!backendLoading) dispatch(loadBackendStatus(currentExperimentId));
    // need to load the samples to get the selected technology of the experiment
    // in the future, selected technology can be moved to under .experiments
    if (!samples[experimentData === null || experimentData === void 0 || (_experimentData$sampl = experimentData.sampleIds) === null || _experimentData$sampl === void 0 ? void 0 : _experimentData$sampl[0]]) dispatch(loadSamples(routeExperimentId));
    if (isBrowser) {
      import('utils/socketConnection').then(function (_ref3) {
        var socketConnection = _ref3.default;
        return socketConnection();
      }).then(function (io) {
        var cb = experimentUpdatesHandler(dispatch);
        var onHeartbeat = workerHeartbeatHandler(dispatch);

        // Unload all previous socket.io hooks that may have been created for a different
        // experiment.
        io.off();
        io.on("ExperimentUpdates-".concat(currentExperimentId), function (update) {
          return cb(currentExperimentId, update);
        });
        io.on("Heartbeat-".concat(currentExperimentId), function (message) {
          return onHeartbeat(currentExperimentId, message);
        });
      });
    }
  }, [routeExperimentId, currentExperimentId]);
  useEffect(function () {
    if (backendStatusRequested) {
      return;
    }
    setBackendStatusRequested(true);
  }, [backendLoading]);
  useEffect(function () {
    var setupPipeline = isSeurat ? 'seurat' : 'gem2s';
    var _ref4 = backendStatus !== null && backendStatus !== void 0 ? backendStatus : {},
      qcBackendStatus = _ref4.pipeline,
      setupBackendStatus = _ref4[setupPipeline];
    if (!experiment || !setupBackendStatus) return;

    // The value of backend status is null for new experiments that have never run

    setPipelinesRerunStatus(calculatePipelinesRerunStatus(setupBackendStatus, qcBackendStatus, experiment, isSeurat, isAnndata, isImmuneOnly));
  }, [backendStatus, experiment, samples, isImmuneOnly]);
  useEffect(function () {
    if (!isImmuneOnly || !routeExperimentId || pipelinesRerunStatus !== null && pipelinesRerunStatus !== void 0 && pipelinesRerunStatus.rerun || _isNil(backendStatus) || backendStatus.pipeline.status !== pipelineStatusValues.SUCCEEDED) return;

    // Redirect Immune only projects when they are done running
    if (currentModule === modules.DATA_PROCESSING || currentModule === modules.DATA_EXPLORATION) {
      navigateTo(modules.PLOTS_AND_TABLES, {
        experimentId: routeExperimentId
      });
    }
  }, [isImmuneOnly, pipelinesRerunStatus, currentModule, routeExperimentId, backendStatus]);
  useEffect(function () {
    if (!routeExperimentId || !(seuratComplete || anndataComplete) || currentModule !== modules.DATA_PROCESSING) return;
    navigateTo(modules.DATA_EXPLORATION, {
      experimentId: routeExperimentId
    });
  }, [seuratComplete, anndataComplete, currentModule, routeExperimentId]);
  useEffect(function () {
    dispatch(loadUser());
  }, []);
  if (!user && userLoadError) {
    return __jsx(PlatformError, {
      description: 'We couldn\'t load your account.',
      reason: userLoadError,
      onClick: function onClick() {
        return dispatch(loadUser());
      }
    });
  }
  if (!user) return null;
  var getStatusObject = function getStatusObject(type, status) {
    var message = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var completedSteps = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    return _objectSpread(_objectSpread({
      type: type,
      status: status
    }, message && {
      message: message
    }), completedSteps && {
      completedSteps: completedSteps
    });
  };
  var gem2sNotCreated = checkEveryIsValue([gem2sStatusKey, seuratStatusKey], pipelineStatusValues.NOT_CREATED);
  var getSeuratStatus = function getSeuratStatus() {
    if (seuratRunningError) {
      var _backendStatus$seurat3;
      var code = backendStatus === null || backendStatus === void 0 || (_backendStatus$seurat3 = backendStatus.seurat) === null || _backendStatus$seurat3 === void 0 || (_backendStatus$seurat3 = _backendStatus$seurat3.error) === null || _backendStatus$seurat3 === void 0 ? void 0 : _backendStatus$seurat3.error;
      var errorMessage = pipelineErrorUserMessages[code];
      return getStatusObject('seurat', 'error', errorMessage);
    }
    if (seuratRunning) {
      return getStatusObject('seurat', 'running', null, completedSeuratSteps);
    }
    return null;
  };
  var getGem2sStatus = function getGem2sStatus() {
    if (gem2sRunningError) return getStatusObject('gem2s', 'error');
    if (gem2sRunning && experiment !== null && experiment !== void 0 && experiment.isSubsetted) {
      return getStatusObject('gem2s', 'subsetting', null, completedGem2sSteps);
    }
    if (gem2sRunning || waitingForQcToLaunch) {
      return getStatusObject('gem2s', 'running', null, completedGem2sSteps);
    }
    if (gem2sNotCreated) return getStatusObject('gem2s', 'toBeRun');
    return null;
  };
  var getQcStatus = function getQcStatus() {
    if (currentModule !== modules.DATA_PROCESSING) {
      if (qcRunningError) return getStatusObject('qc', 'error');
      if (qcRunning) return getStatusObject('qc', 'running');
      if (qcStatusKey === pipelineStatusValues.NOT_CREATED) {
        return getStatusObject('qc', 'toBeRun');
      }
    }
    return null;
  };
  var getCurrentStatusScreen = function getCurrentStatusScreen() {
    if (isSeurat) {
      return getSeuratStatus();
    }
    // Anndata never launches qc (same as seurat), so don't fall through to getQcStatus() —
    // that would misreport 'qc toBeRun' once the anndata run finishes.
    if (isAnndata) {
      return getGem2sStatus();
    }
    return getGem2sStatus() || getQcStatus();
  };
  var currentStatusScreen = getCurrentStatusScreen();
  var getTertiaryModuleDisabled = function getTertiaryModuleDisabled(module) {
    var disableIfNoExperiment = false;
    var disabledByPipelineStatus = false;
    var disabledIfSeuratComplete = false;
    var disabledIfImmuneOnly = false;
    switch (module) {
      case modules.DATA_PROCESSING:
        disableIfNoExperiment = true;
        disabledIfSeuratComplete = true;
        disabledIfImmuneOnly = true;
        break;
      case modules.DATA_EXPLORATION:
        disableIfNoExperiment = true;
        disabledByPipelineStatus = true;
        disabledIfImmuneOnly = true;
        break;
      case modules.PLOTS_AND_TABLES:
        disableIfNoExperiment = true;
        disabledByPipelineStatus = true;
        break;
      default:
        break;
    }
    var needRerunPipeline = pipelinesRerunStatus === null || pipelinesRerunStatus.rerun;
    var notProcessedExperimentDisable = !routeExperimentId && disableIfNoExperiment && needRerunPipeline;
    var pipelineStatusDisable = disabledByPipelineStatus && (backendError || gem2sRunning || gem2sRunningError || waitingForQcToLaunch || qcRunning || qcRunningError || seuratRunning || seuratRunningError);
    var DATA_EXPLORATION = modules.DATA_EXPLORATION,
      DATA_MANAGEMENT = modules.DATA_MANAGEMENT,
      DATA_PROCESSING = modules.DATA_PROCESSING,
      PLOTS_AND_TABLES = modules.PLOTS_AND_TABLES;
    var nonExperimentModule = ![DATA_EXPLORATION, DATA_MANAGEMENT, DATA_PROCESSING, PLOTS_AND_TABLES].includes(currentModule) && disableIfNoExperiment;
    var seuratCompleteDisable = disabledIfSeuratComplete && (isSeurat || isAnndata);
    var immuneOnlyDisable = disabledIfImmuneOnly && isImmuneOnly;
    return notProcessedExperimentDisable || pipelineStatusDisable || seuratCompleteDisable || nonExperimentModule || immuneOnlyDisable;
  };
  var menuLinks = [
  // uncomment the following when the sample loading table module is ready
  {
    module: modules.SAMPLE_LOADING_TABLE,
    icon: __jsx(TableOutlined, null),
    name: __jsx(SidebarMenuTitle, {
      type: modules.SAMPLE_LOADING_TABLE
    }, "Sample Loading Table"),
    selectedProjectText: activeSltName || 'No table selected',
    items: []
  }, {
    module: modules.SECONDARY_ANALYSIS,
    icon: __jsx(NodeExpandOutlined, null),
    name: __jsx(SidebarMenuTitle, {
      type: modules.SECONDARY_ANALYSIS
    }, "Pipeline"),
    selectedProjectText: secondaryAnalysisName || 'No run selected',
    isDisabled: false,
    items: [{
      module: modules.SECONDARY_ANALYSIS_OUTPUT,
      name: __jsx(SidebarMenuTitle, {
        type: modules.SECONDARY_ANALYSIS_OUTPUT
      }, "Pipeline Output"),
      icon: __jsx(FileDoneOutlined, null),
      get isDisabled() {
        return !activeSecondaryAnalysisId || analysisStatus && analysisStatus === 'not_created' && currentModule === modules.SECONDARY_ANALYSIS;
      }
    }]
  }, {
    module: modules.DATA_MANAGEMENT,
    icon: __jsx(DotChartOutlined, null),
    name: __jsx(SidebarMenuTitle, {
      type: modules.DATA_MANAGEMENT
    }, "Insights"),
    selectedProjectText: experimentName || 'No project selected',
    get isDisabled() {
      return getTertiaryModuleDisabled(this.module);
    },
    items: [{
      module: modules.DATA_PROCESSING,
      icon: __jsx(BuildOutlined, null),
      name: __jsx(SidebarMenuTitle, {
        type: modules.DATA_PROCESSING,
        tooltipText: isImmuneOnly && getTertiaryModuleDisabled(modules.DATA_PROCESSING) ? 'This module is not available for immune repertoire projects without parent whole transcriptome data.' : null
      }, "Data Processing"),
      get isDisabled() {
        return getTertiaryModuleDisabled(this.module);
      }
    }, {
      module: modules.DATA_EXPLORATION,
      icon: __jsx(FundViewOutlined, null),
      name: __jsx(SidebarMenuTitle, {
        type: modules.DATA_EXPLORATION,
        tooltipText: isImmuneOnly && getTertiaryModuleDisabled(modules.DATA_EXPLORATION) ? 'This module is not available for immune repertoire projects without parent whole transcriptome data.' : null
      }, "Data Exploration"),
      get isDisabled() {
        return getTertiaryModuleDisabled(this.module);
      }
    }, {
      module: modules.PLOTS_AND_TABLES,
      icon: __jsx(BarChartOutlined, null),
      name: __jsx(SidebarMenuTitle, {
        type: modules.PLOTS_AND_TABLES
      }, "Plots and Tables"),
      get isDisabled() {
        return getTertiaryModuleDisabled(this.module);
      }
    }]
  }];
  var renderContent = function renderContent() {
    if (routeExperimentId) {
      if (backendLoading || !backendStatusRequested) {
        return __jsx(PreloadContent, null);
      }

      // TODO decide whether we want to move this and GEM2SLoadingScreen
      // into data-processing/index.jsx instead of here.
      // Right now we are just making ContentWrapper display
      // what data-processing would display in this case

      if (isImmuneOnly) {
        if (currentModule === modules.DATA_PROCESSING) {
          return __jsx(ImmuneOnlyLoadingScreen, {
            experimentId: routeExperimentId
          });
        }
        return children;
      }

      // Object uploads have no QC to show, hold until the redirect to data exploration runs
      if ((seuratComplete || anndataComplete) && currentModule === modules.DATA_PROCESSING) {
        return __jsx(PreloadContent, null);
      }
      if (currentStatusScreen && currentStatusScreen.type !== 'qc') {
        return __jsx(GEM2SLoadingScreen, {
          experimentId: routeExperimentId,
          pipelineStatus: currentStatusScreen.status,
          pipelineType: currentStatusScreen.type,
          pipelineErrorMessage: currentStatusScreen === null || currentStatusScreen === void 0 ? void 0 : currentStatusScreen.message,
          completedSteps: currentStatusScreen === null || currentStatusScreen === void 0 ? void 0 : currentStatusScreen.completedSteps,
          isCopying: copyInProgress,
          experimentName: experimentName
        });
      }
      if ((currentStatusScreen === null || currentStatusScreen === void 0 ? void 0 : currentStatusScreen.type) === 'qc') {
        return __jsx(PipelineRedirectToDataProcessing, {
          experimentId: routeExperimentId,
          pipelineStatus: currentStatusScreen.status
        });
      }
      if (process.env.NODE_ENV === 'development') {
        return children;
      }
    }
    return children;
  };
  var menuItemRender = function menuItemRender(_ref5) {
    var module = _ref5.module,
      items = _ref5.items,
      icon = _ref5.icon,
      name = _ref5.name,
      selectedProjectText = _ref5.selectedProjectText,
      isDisabled = _ref5.isDisabled;
    var _onClick = function onClick(targetModule) {
      navigateTo(targetModule, {
        experimentId: currentExperimentId,
        secondaryAnalysisId: currentAnalysisIdRef.current
      });
    };
    if (_isEmpty(items)) {
      return __jsx(Item, {
        key: module,
        icon: icon,
        disabled: isDisabled,
        onClick: function onClick() {
          return _onClick(module);
        }
      }, name);
    }
    return __jsx(SubMenu, {
      key: module,
      title: name,
      icon: icon,
      disabled: isDisabled,
      onTitleClick: function onTitleClick() {
        return _onClick(module);
      }
    }, __jsx(ItemGroup, {
      key: "active project",
      title: __jsx(Text, {
        style: {
          width: '100%',
          color: 'grey'
        },
        ellipsis: {
          tooltip: true
        }
      }, selectedProjectText)
    }, items.map(function (item) {
      return __jsx(Item, {
        key: item.module,
        disabled: item.isDisabled,
        icon: item.icon,
        onClick: function onClick() {
          _onClick(item.module);
        }
      }, item.name);
    })));
  };
  if (!user) return null;
  var menuItems = menuLinks.map(menuItemRender);
  var isUserInModule = function isUserInModule(module, items) {
    return currentModule === module || items.some(function (item) {
      return item.module === currentModule;
    });
  };
  var expandedWidth = 230;
  return __jsx(DndProvider, {
    options: HTML5toTouch
  }, termsOfUseNotAccepted(user, domainName) && currentModule && currentModule !== modules.SAMPLE_LOADING_TABLE && __jsx(TermsOfUseIntercept, {
    user: user
  }), __jsx(BrowserAlert, null), __jsx(_Layout, {
    style: {
      minHeight: '100vh',
      paddingTop: "".concat(topBannerHeight, "px")
    }
  }, __jsx(TopBanner, {
    onHeightChange: setTopBannerHeight
  }), __jsx(Sider, {
    style: {
      background: brandColors.BLACK_INDIGO,
      overflow: 'auto',
      height: "calc(100vh - ".concat(topBannerHeight, "px)"),
      position: 'fixed',
      top: "".concat(topBannerHeight, "px"),
      left: 0
    },
    width: expandedWidth,
    theme: "dark",
    mode: "inline",
    collapsible: true,
    collapsed: collapsed,
    onCollapse: function onCollapse(collapse) {
      return setCollapsed(collapse);
    }
  }, __jsx("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%'
    }
  }, collapsed ? __jsx(SmallLogo, null) : __jsx(BigLogo, null), __jsx(_Menu, {
    style: {
      background: brandColors.BLACK_INDIGO
    },
    "data-test-id": integrationTestConstants.ids.NAVIGATION_MENU,
    theme: "dark",
    selectedKeys: [currentModule],
    mode: "inline",
    openKeys: collapsed ? undefined : menuLinks.filter(function (item) {
      return item.items.length > 0 && isUserInModule(item.module, item.items);
    }).map(function (item) {
      return item.module;
    })
  }, menuItems), __jsx("div", {
    style: {
      marginTop: 'auto',
      marginBottom: '0.5em',
      textAlign: collapsed ? 'center' : 'left'
    }
  }, __jsx(LinkButton, {
    icon: __jsx(ReadOutlined, null),
    link: "https://support.parsebiosciences.com/hc/en-us/articles/27076682137236-Trailmaker-User-Guide",
    collapsed: collapsed,
    text: "User guide"
  }), __jsx(FeedbackButton, {
    buttonType: "text",
    collapsed: collapsed
  }), __jsx(LinkButton, {
    icon: __jsx(ExperimentOutlined, null),
    link: "https://www.parsebiosciences.com/technology/",
    collapsed: collapsed,
    text: __jsx(React.Fragment, null, "Learn about Evercode", __jsx("sup", {
      style: {
        fontSize: '0.6em',
        verticalAlign: 'top'
      }
    }, "TM"))
  }), __jsx(LinkButton, {
    icon: __jsx(CommentOutlined, null),
    link: "https://www.parsebiosciences.com/lets-connect/?rfqsource=trailmaker",
    collapsed: collapsed,
    text: "Talk to a single cell expert"
  }), __jsx(_Divider, {
    style: {
      backgroundColor: 'hsla(0, 0%, 100%, .65)',
      height: '0.5px'
    }
  }), __jsx("div", {
    style: {
      margin: '0.5em 0',
      textAlign: 'center'
    }
  }, __jsx(UserButton, null), __jsx("br", null), __jsx("br", null), __jsx("span", {
    style: {
      fontSize: '0.75em',
      color: 'hsla(0, 0%, 100%, 0.65)'
    }
  }, "\xA9", ' ', __jsx("a", {
    href: "https://parsebiosciences.com/",
    style: {
      color: 'inherit',
      textDecoration: 'none'
    }
  }, "Parse Biosciences"), ' ', "2020-2026.", __jsx("br", null), "All rights reserved."))))), __jsx(CookieBanner, null), __jsx(_Layout, {
    style: !collapsed ? {
      marginLeft: "".concat(expandedWidth, "px")
    } : {
      marginLeft: '80px'
    } // this is the collapsed width for our sider
  }, renderContent())));
};
ContentWrapper.defaultProps = {
  routeExperimentId: null,
  routeAnalysisId: null,
  experimentData: null,
  children: null
};
export default ContentWrapper;